import { render, staticRenderFns } from "./JdsTable.vue?vue&type=template&id=24dda1b6&scoped=true&"
import script from "./JdsTable.vue?vue&type=script&lang=ts&"
export * from "./JdsTable.vue?vue&type=script&lang=ts&"
import style0 from "./JdsTable.vue?vue&type=style&index=0&id=24dda1b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dda1b6",
  null
  
)

export default component.exports